import React from 'react';
import '../Assets/Css/routine.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTools, FaWrench, FaClipboardCheck } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutMaintenanceImg from '../Assets/Images/aboutmaintenance.avif';
import electricalImg from '../Assets/Images/electrical_maintenance.avif';
import plumbingImg from '../Assets/Images/plumbing_maintenance.avif';
import hvacImg from '../Assets/Images/hvac_maintenance.avif';
import maintenanceCtaImg from '../Assets/Images/maintenance_cta.avif';
import { Helmet } from 'react-helmet';

export default function RoutineMaintenance() {
  const testimonials = [
    {
      message: "The team is responsive and skilled. They handle issues before we even notice them!",
      author: "Facility Manager",
    },
    {
      message: "Our building systems have never been more reliable. Great ongoing service!",
      author: "Admin Head",
    },
    {
      message: "Prompt, professional, and thorough maintenance staff. Highly recommended.",
      author: "Operations Manager",
    },
  ];

  const features = [
    {
      id: 1,
      icon: <FaTools />,
      title: "Skilled Technicians",
      description: "Our trained professionals handle all types of routine maintenance tasks.",
    },
    {
      id: 2,
      icon: <FaWrench />,
      title: "Preventive Care",
      description: "Prevent breakdowns with regular inspections and servicing.",
    },
    {
      id: 3,
      icon: <FaClipboardCheck />,
      title: "Compliance & Reporting",
      description: "We ensure safety and operational compliance with detailed records.",
    },
  ];

  const services = [
    {
      title: 'Electrical Maintenance',
      description: 'From lighting to panel upgrades, our electricians keep your system safe and efficient.',
      image: electricalImg,
    },
    {
      title: 'Plumbing Services',
      description: 'We maintain water systems, fix leaks, and handle routine plumbing repairs.',
      image: plumbingImg,
    },
    {
      title: 'HVAC Maintenance',
      description: 'Keep your air conditioning and ventilation systems running smoothly all year.',
      image: hvacImg,
    },
  ];

  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        <title>Routine Maintenance Services | Preventive Facility Maintenance | Samashree Enterprises</title>
        <meta
          name="description"
          content="Samashree Enterprises offers certified routine maintenance services including electrical, plumbing, and HVAC maintenance to keep commercial and residential properties running smoothly."
        />
        <meta
          name="keywords"
          content="routine maintenance, preventive maintenance, electrical maintenance, plumbing services, HVAC maintenance, facility maintenance, property maintenance"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.samashreeenterprises.com/routine-maintenance-services" />

        {/* Open Graph */}
        <meta property="og:title" content="Routine Maintenance Services | Samashree Enterprises" />
        <meta
          property="og:description"
          content="Reliable routine maintenance services with certified technicians, customized plans, and preventive care for commercial and residential properties."
        />
        <meta property="og:url" content="https://www.samashreeenterprises.com/routine-maintenance-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.samashreeenterprises.com/images/maintenance-banner.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Routine Maintenance Services | Samashree Enterprises" />
        <meta
          name="twitter:description"
          content="Expert routine maintenance: electrical, plumbing, HVAC services to keep your facility safe and efficient."
        />
        <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/maintenance-banner.jpg" />
      </Helmet>
      

      {/* Hero Section */}
      <section className="hero-section5">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Routine Maintenance Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">Reliable, preventive maintenance to keep your facilities running smoothly.</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
             <Col md={6} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutMaintenanceImg}
                alt="About Maintenance"
                  className="img-fluid aboutsecimg rounded shadow mb-3"
                  data-aos="zoom-in" data-aos-delay="100"
              />
            </Col>
            <Col md={6}>
              <h2 className="page-title text-center" data-aos="fade-up" > Overview</h2>
              <p data-aos="zoom-in" data-aos-delay="100">
               We at Samashree Enterprises Pvt. Ltd. provides routine maintenance services to maintain roads in healthy & safe conditions so that users might be safe while using the highways.
                Some services provided by us are as below: -
              </p>
              <ul data-aos="zoom-in" data-aos-delay="100">
  <li>Pothole Patching: Promptly repairing potholes prevents further deterioration and reduces the risk of accidents or damage to vehicles.</li>
  <li>Crack Sealing: Sealing cracks in the pavement prevents water infiltration, which can lead to potholes and further damage.</li>
  <li>Line Striping: Repainting lane markings and road signage improves visibility and ensures clear guidance for motorists, especially in adverse weather conditions.</li>
  <li>Cleaning Drainage Structures: Ensuring proper functioning of ditches, culverts, and drainage structures prevents water accumulation and erosion.</li>
  <li>Vegetation Control: Maintaining clear sightlines and preventing vegetation from damaging road infrastructure.</li>
  <li>Signage Upkeep: Ensuring that road signs are clean, legible, and properly placed.</li>
  <li>Bridge Maintenance: Inspecting and repairing bridges to ensure their structural integrity.</li>
  <li>Shoulder Maintenance: Maintaining shoulders, which can include re-graveling.</li>
  <li>Surface Dressing: Applying a thin layer of asphalt and aggregate to the road surface to restore it.</li>
</ul>

            </Col>
           
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
    <section>
       <h2 className="page-title text-center" data-aos="fade-up" >Why Choose Us</h2>
       <section className="why-choose-us-bg3 py-4 bg-light">
        <Container>
         
          <Row className="text-center">
            {features.map(({ id, icon, title, description }) => (
              <Col key={id} md={4} className="mb-4">
                <Card className="feature-card h-100 p-4 shadow-sm" data-aos="zoom-in" data-aos-delay="100">
                  <div className="icon-box mb-3" style={{ fontSize: "2.5rem", color: "#008080" }}>
                    {icon}
                  </div>
                  <Card.Title>{title}</Card.Title>
                  <Card.Text>{description}</Card.Text>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </section>
      

      {/* Services Section */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" data-aos-delay="100">Our Routine Maintenance  Services</h2>
          <Row>
            {services.map((service, index) => (
              <Col md={4} sm={12} className="mb-4" key={index}>
                <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
                  <Card.Img variant="top" src={service.image} alt={service.title} className="service-image" />
                  <Card.Body>
                    <Card.Title style={{ color: '#008080', textAlign: 'center' }}>{service.title}</Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
             <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Need Reliable Maintenance?</h2>
              <p className="lead">Let's keep your facility running like clockwork. Contact us today!</p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={maintenanceCtaImg}
                  alt="Maintenance team"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" >What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
